import React from "react";
import API_URL from "../config/ApiUrl";
export class ApiService {
  static async getAllProducts() {
    try {
      const response = await fetch(`${API_URL}/api/get-products`);
      if (!response.ok) throw new Error('Failed to fetch products');
      return await response.json();
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  }

  static async getProduct(productId) {
    try {
      const response = await fetch(`${API_URL}/api/get-product/${productId}`);
      if (!response.ok) throw new Error('Failed to fetch product');
      return await response.json();
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  }

  static async getAllProductsPagination(page = 1, limit = 10, sortBy = 'rating', category = null, effects = null, priceMin = null, priceMax = null, searchQuery = null,
  strainType = null) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        sort_by: sortBy
      });
      
      if (category) params.append('category', category);
      if (effects) params.append('effects', effects);
      if (priceMin) params.append('price_min', priceMin);
      if (priceMax) params.append('price_max', priceMax);
      if (searchQuery) params.append('search', searchQuery); // Add search parameter
      if (strainType) params.append('strain_type', strainType);

      const response = await fetch(`${API_URL}/api/get-products-pagination?${params}`);
      if (!response.ok) throw new Error('Failed to fetch products');
      return await response.json();
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  }
  static async getAllDiscoverProducts(page = 1, limit = 10, sortBy = 'rating', category = null) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        sort_by: sortBy
      });
      
      if (category) {
        params.append('category', category);
      }
      
      const response = await fetch(`${API_URL}/api/get-discovery-products?${params}`, {credentials: 'include'});
      if (!response.ok) throw new Error('Failed to fetch products');
      return await response.json();
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  }

  // ADD STATIC KEYWORD HERE
  static async createReview(productId, rating, effects = []) {
    try {
      const response = await fetch(`${API_URL}/api/reviews`, {
        method: 'POST',
        credentials: 'include',

        headers: {
          'Content-Type': 'application/json',
          // Add your auth headers here if needed
          // 'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          product_id: productId,
          rating: rating,
          content: "Review from discovery swipe",
          effects: effects
        })
      });
      
      if (!response.ok) throw new Error('Failed to create review');
      return await response.json();
    } catch (error) {
      console.error('Error creating review:', error);
      throw error;
    }
  }
  static async voteReview(reviewId, value) {
    try {
      const response = await fetch(`${API_URL}/api/reviews/${reviewId}/vote`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ value })
      });

      if (!response.ok) throw new Error('Failed to vote on review');
      return await response.json();
    } catch (error) {
      console.error('Error voting on review:', error);
      throw error;
    }
  }

  static async getReviewedProducts(page = 1, limit = 10, ratingFilter = null) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString()
      });
      
      if (ratingFilter) {
        params.append('rating', ratingFilter.toString());
      }
      
      const response = await fetch(`${API_URL}/api/get-reviewed-products?${params}`, {
        credentials: 'include'
      });
      if (!response.ok) throw new Error('Failed to fetch reviewed products');
      return await response.json();
    } catch (error) {
      console.error('Error fetching reviewed products:', error);
      throw error;
    }
  }

  // Get review replies
  static async getReviewReplies(reviewId) {
    try {
      const response = await fetch(`${API_URL}/api/reviews/${reviewId}/replies`, {
        credentials: 'include'
      });

      if (!response.ok) throw new Error('Failed to fetch replies');
      return await response.json();
    } catch (error) {
      console.error('Error fetching replies:', error);
      throw error;
    }
  }

  // Create review reply
  static async createReviewReply(reviewId, content, replyToId = null) {
    try {
      const response = await fetch(`${API_URL}/api/reviews/${reviewId}/replies`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ 
          content,
          reply_to_id: replyToId 
        })
      });

      if (!response.ok) throw new Error('Failed to create reply');
      return await response.json();
    } catch (error) {
      console.error('Error creating reply:', error);
      throw error;
    }
  }

  // Vote on review reply
  static async voteReviewReply(replyId, value) {
    try {
      const response = await fetch(`${API_URL}/api/review-replies/${replyId}/vote`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ value })
      });

      if (!response.ok) throw new Error('Failed to vote on reply');
      return await response.json();
    } catch (error) {
      console.error('Error voting on reply:', error);
      throw error;
    }
  }
}

// ADD DEFAULT EXPORT
export default ApiService;